/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { ReactElement } from 'react';
import MatchedVisasItemDesktop from '../MatchedVisasItemDesktop';
import { placeholderVisaData } from '../../../../../../data/constants/constants';
import '../MatchedVisasDashboard-Desktop.scss';

type MatchedVisasDesktopProps = {
    assessmentScore: any[];
    openCloseLearnMoreModal: () => void;
    paid?: boolean;
};

function MatchedVisasDesktop({
    assessmentScore,
    openCloseLearnMoreModal,
    paid,
}: MatchedVisasDesktopProps): ReactElement | null {
    const isAssessmentScoreEmpty = assessmentScore.length === 0;
    const relevantData = isAssessmentScoreEmpty ? placeholderVisaData : assessmentScore;

    return (
        <div className={'MatchedVisasBody'} onClick={openCloseLearnMoreModal}>
            {relevantData.map((item: any) => (
                <MatchedVisasItemDesktop
                    key={item.country}
                    countryVisaData={item}
                    isAssessmentScoreEmpty={isAssessmentScoreEmpty}
                    paid={paid}
                />
            ))}
        </div>
    );
}

export default MatchedVisasDesktop;
